import { cachedReleasesKey, assetHost, lang } from "../app";
export const fetchCachedNews = userLevel => {
	return new Promise(async (resolve, reject) => {
		try {
			const response = await $.ajax(`${assetHost}/${cachedReleasesKey}`);
			let now = new Date().getTime();
			resolve({
				type: "list",
				data: response[0][lang].filter(item => item.langs[lang].pubTime <= now)
			});
			// items are cached regardless of lang pubTime,
			// so we must manage that filtering here
		} catch (err) {
			reject(err);
		}
	});
	// end Promise definition
};
// end fetchCachedNews function
